import Bowser from "bowser"

export default {
  computed: {
    pageName() {
      return this.$route.meta.label
    }
  },
  methods: {
    trackExpMethod() {
      let string = document.visibilityState
      if (string === 'hidden') {
        // 当页面由前端运行在后端时，出发此代码
        console.log('我被隐藏了')
      }
      if (string === 'visible') {
        // 当页面由隐藏至显示时
        console.log('欢迎回来')
        window.sensors.track('TIKU_mainpage_exp', {
          page_Name: this.$route.meta.label
        })
      }
    },
    trackPerformanceStatistics() {
      const performance = window.performance

      if (!performance) {
        // 当前浏览器不支持
        console.log('你的浏览器不支持 performance 接口')
        return
      }

      const { timing } = performance
      const { userAgent } = window.navigator
      const NEW_PAGE_COST = timing.fetchStart - timing.navigationStart // 准备新页面时间耗时
      const APPCACHE_COST = timing.domainLookupStart - timing.fetchStart // Appcache 耗时
      const DNS_COST = timing.domainLookupEnd - timing.domainLookupStart // DNS 查询耗时
      const TCP_COST = timing.connectEnd - timing.connectStart // TCP连接耗时
      const REQUEST_COST = timing.responseEnd - timing.requestStart // request请求耗时
      const DOM_COST = timing.domInteractive - timing.responseEnd // 请求完毕至DOM加载
      const LOAD_COST = timing.loadEventEnd - timing.loadEventStart // load事件耗时
      const LOAD_FINISH = timing.loadEventEnd - timing.navigationStart // 从开始至load完成
      const PAGE_COST = timing.loadEventStart - timing.navigationStart // 页面加载耗时
      // 如果我们需要尽量对页面加载周期的数据进行详细的统计分析：
      window.sensors.track('CMINE_FE_PERFORMANCE', {
        page_Name: this.$route.meta.label,
        NEW_PAGE_COST,
        APPCACHE_COST,
        DNS_COST,
        TCP_COST,
        REQUEST_COST,
        DOM_COST,
        LOAD_COST,
        LOAD_FINISH,
        PAGE_COST,
        userAgent
      })
    }
  },
  mounted() {
    const { browser, engine, os, platform } = Bowser.parse(window.navigator.userAgent)
    let regions = this.$store.state.user_info && this.$store.state.user_info.regions
    let _province = regions && regions.length > 0 ? regions[0].name : '未知'
    let _city = regions && regions.length > 1 ? regions[1].name : '未知'
    let _area = regions && regions.length > 2 ? regions[2].name : '未知'
    let that = this
    const env = process.env.VUE_APP_MODE || 'development'
    // 设置channel
    let result = ''
    const channel = this.$route.query._c
    const storeChannel = this.$store.state.channel
    // 如果 url 中存在 _c ，那么直接设置为，公共参数 channel ，如果不存在，首先查看store中是否存在
    if (channel) {
      this.$store.commit('SET_CHANNEL', channel)
      result = channel
    } else {
      if (storeChannel) {
        result = storeChannel
      } else {
        result = ''
      }
    }

    window.sensors.registerPage({
      platform: 'Web',
      product: '内容库',
      subject: String(this.$store.state.subject.value),
      _province,
      _city,
      _area,
      env,
      channel: result,
      // 新增公共属性 ---- 浏览器信息
      _browser_name: browser && browser.name,
      _browser_version: browser && browser.version,
      _engine_name: engine && engine.name,
      _os_name: os && os.name,
      _os_version: os && os.version,
      _os_version_name: os && os.versionName,
      _platform_type: platform && platform.type,
      _platform_vendor: platform && platform.vendor
    })
    setTimeout(() => {
      window.sensors.quick('autoTrackSinglePage')
      window.sensors.track('TIKU_mainpage_exp', {
        page_Name: that.$route.meta.label
      })
      // 增加曝光采集
      document.addEventListener('visibilitychange', this.trackExpMethod, false)
      this.trackPerformanceStatistics()
    }, 200)
  },
  beforeDestroy() {
    // 增加曝光采集
    document.removeEventListener('visibilitychange', this.trackExpMethod, false)
  }
}
